import React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import { Box } from "@mui/material";

export default function CustomMenu({
  buttonLabel,
  children,
  style,
  open,
  anchorEl,
  handleClick,
  handleClose,
}) {
  return (
    <Box sx={{ ...style }}>
      <Box
        sx={{ cursor: "pointer" }}
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        {buttonLabel}
      </Box>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        PaperProps={{
          style: {
            padding: "0px",
          },
        }}
      >
        {children}
      </Menu>
    </Box>
  );
}
